<template>
  <div>
    <div v-if="loading" class="text-xs-center mt-4 mb-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else-if="user">
      <template v-if="theme == 'universalutilities'">
        <uu-customer-detail v-model="user" :pageid="pageid">
          <div slot="header">&nbsp;</div>
        </uu-customer-detail>
      </template>
      <template v-else-if="['hafele', 'scgallrent'].includes(theme)">
        <customer-detail v-model="user.id" :getuseronly="true" :pageid="pageid">
          <div slot="header">&nbsp;</div>
        </customer-detail>
      </template>
      <template
        v-else-if="
          ['ticket', ...$store.state.ticketThemeList].includes(theme) ||
          $store.state.ticketPageid.includes(selectedBot.pageid)
        "
      >
        <ticket-customer-detail v-model="user.id" :pageid="pageid" parent="livechat">
          <div slot="header">&nbsp;</div>
        </ticket-customer-detail>
      </template>
      <template v-else-if="$store.state.toapainterpage.includes(pageid)">
        <toa-painter-info v-model="user" :readonly="true" :user="user" :pageid="pageid">
          <div slot="header">&nbsp;</div>
        </toa-painter-info>
      </template>
      <template v-else>
        <customer-detail v-model="user" :pageid="pageid" :getuseronly="true" :loaduser="false">
          <div slot="header">&nbsp;</div>
        </customer-detail>
      </template>
      <template v-if="$aston.astonpages.includes($store.state.livechat.pageid)">
        <v-divider />
        <div class="px-2">
          <div class="mt-4">Assign to</div>
          <v-select
            v-model="assignadminname"
            :items="computedAstonAdmins"
            outline
            label="Assign to"
            hide-details
            class="mt-1"
            color="primary"
            @change="changeAsssign"
          ></v-select>

          <div class="mt-4">ประเภทลูกค้า</div>
          <v-select
            v-model="session"
            :items="$store.state.astonCustomerGroup"
            outline
            label="ประเภทลูกค้า"
            hide-details
            class="mt-1"
            color="primary"
            @change="changeSession"
          ></v-select>
          <div class="mb-4"></div>
        </div>
      </template>
    </div>
    <div v-else>
      <div class="text-xs-center mt-4 mb-4">
        <v-icon x-large>error_outline</v-icon>
        <p>No detail</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import CustomerDetail from '@/components/view/dashboard/customer/CustomerDetail.vue'
import UuCustomerDetail from '@/components/view/dashboard/customize/uu/UuCustomerDetail.vue'
import TicketCustomerDetail from '@/components/view/dashboard/TicketCustomerDetail.vue'
import ToaPainterInfo from '@/components/view/dashboard/customize/ToaPainterInfo.vue'
export default {
  components: {
    CustomerDetail,
    UuCustomerDetail,
    TicketCustomerDetail,
    ToaPainterInfo
  },
  props: ['value', 'pageid', 'theme'],
  data: function () {
    return {
      loading: true,
      user: undefined,
      chatboxHeight: 0,
      session: '',
      assignadminname: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins'
    }),
    computedAstonAdmins() {
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        if (this.astonAdmins) {
          var admins = this.astonAdmins.map((el) => {
            return {
              text: el.name,
              value: el.name
            }
          })
          admins.unshift({ text: 'ยังไม่ได้ Assign', value: '' })
          return admins
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      var vm = this

      if (newVal == null) {
        vm.user = undefined
      } else if (newVal.id != oldVal.id) {
        vm.loading = true

        vm.getUser(newVal.userid).then(
          function (user) {
            if (user) {
              vm.user = user
            }
            vm.loading = false
          },
          function (error) {
            vm.loading = false
            console.error(error)
          }
        )
      }
    }
  },
  mounted: function () {
    var vm = this

    vm.loading = true

    vm.getUser(vm.value.userid).then(
      function (user) {
        if (user) {
          vm.user = user
          vm.session = user.session ? user.session : ''
          vm.assignadminname = user.adminname
        }
        vm.loading = false
      },
      function (error) {
        vm.loading = false
        console.error(error)
      }
    )
  },
  methods: {
    changeAsssign(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          adminname: value
        }
      }
      api.saveuseradminname(data, (error) => {
        if (error) {
          // reject(error)
          console.error(error)
        }
      })
    },
    changeSession(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          session: value
        }
      }
      api.saveusersession(data, (error) => {
        if (error) {
          // reject(error)
          console.error(error)
        }
      })
    },
    onResizeChatbox: function () {
      var vm = this
      setTimeout(() => {
        vm.chatboxHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - 5
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
      }, 500)
    },
    getUser: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.$store.state.livechat.pageid
        }
        api.getUserOnly(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-customers.vue